import { render, staticRenderFns } from "./cityFormInput.vue?vue&type=template&id=90b20c4e&"
import script from "./cityFormInput.vue?vue&type=script&lang=js&"
export * from "./cityFormInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports